import { handleRequest } from "../utilities/requestHandler";

export const getRequestListBySiteId = (reqBody) =>
    handleRequest("post", "/request_list/bysiteid", reqBody);

export const deleteFromRequestList = (reqBody) =>
    handleRequest("post", "/request_list/delete", reqBody);

export const notifyCustomerCare = (req_body) =>
    handleRequest("post", "/request_list/notifycc", req_body);
